module.exports = __webpack_public_path__ + "static/media/christopherhoffman.cbed704f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/christopherhoffman.webp
// module id = 346
// module chunks = 0